import React from 'react';
import PaddingBox from '@uds/padding-box';
import { Button, Kind } from '@uds/button';
import { Glyph } from '@uds/glyphs';
import Message from '@uds/message';
import { Layout } from 'domain/constants/layout';

import getClassNames from './Scroll.stylesheet';

interface OuterProps {
  onScrollClick: (evt: any) => any;
  layout: Layout;
}

export const PureBillboardScroll = ({ onScrollClick, layout }: OuterProps) => {
  const classNames = getClassNames({ layout });
  return (
    <PaddingBox className={classNames.scroller}>
      <Button
        type="button"
        onClick={onScrollClick}
        kind={Kind.TERTIARY}
        glyph={<Glyph name="chevronDown" alt="chevronDown" />}
      >
        <Message id="usf.ribbons.billboard.scroll" />
      </Button>
    </PaddingBox>
  );
};

PureBillboardScroll.displayName = 'BillboardScroll';

export default PureBillboardScroll;
